import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import tournamentService from './tournamentService';
import { setAlertError, setAlertInfo, setAlertSuccess } from '../alert/alertSlice';

export const getAllTournaments = createAsyncThunk(
  'tournament/getAllTournaments',
  async (data, thunkAPI) => {
    return await tournamentService
      .get()
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        setAlertError(thunkAPI.dispatch, err.message);
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const getTournamentById = createAsyncThunk(
  'tournament/getTournamentById',
  async (tournamentId, thunkAPI) => {
    return await tournamentService
      .getById(tournamentId)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        setAlertError(thunkAPI.dispatch, err.message);
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const createTournament = createAsyncThunk(
  'tournament/createTournament',
  async (tournament, thunkAPI) => {
    return await tournamentService
      .create(tournament)
      .then((response) => {
        setAlertSuccess(thunkAPI.dispatch, 'Tournament created successfully');
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        setAlertError(thunkAPI.dispatch, err.message);
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const updateTournament = createAsyncThunk(
  'tournament/updateTournament',
  async ({ tournamentId, tournament }, thunkAPI) => {
    return await tournamentService
      .update(tournamentId, tournament)
      .then((response) => {
        setAlertSuccess(thunkAPI.dispatch, 'Tournament updated successfully');
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        setAlertError(thunkAPI.dispatch, err.message);
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const deleteTournament = createAsyncThunk(
  'tournament/deleteTournament',
  async (tournamentId, thunkAPI) => {
    return await tournamentService
      .remove(tournamentId)
      .then((response) => {
        setAlertInfo(thunkAPI.dispatch, 'Tournament deleted successfully');
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        setAlertError(thunkAPI.dispatch, err.message);
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

const initialState = {
  tournaments: [],
  tournament: null,
  loading: false,
  error: null
};

const tournamentSlice = createSlice({
  name: 'tournament',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTournaments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllTournaments.fulfilled, (state, action) => {
        state.loading = false;
        state.tournaments = action.payload;
      })
      .addCase(getAllTournaments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getTournamentById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getTournamentById.fulfilled, (state, action) => {
        state.loading = false;
        state.tournament = action.payload;
      })
      .addCase(getTournamentById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createTournament.pending, (state) => {
        state.loading = true;
      })
      .addCase(createTournament.fulfilled, (state, action) => {
        state.loading = false;
        state.tournaments.push(action.payload);
      })
      .addCase(createTournament.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateTournament.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateTournament.fulfilled, (state, action) => {
        state.loading = false;
        const index = state.tournaments.findIndex((t) => t.id === action.payload.id);
        if (index !== -1) {
          state.tournaments[index] = action.payload;
        }
      })
      .addCase(updateTournament.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteTournament.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteTournament.fulfilled, (state, action) => {
        state.loading = false;
        state.tournaments = state.tournaments.filter((t) => t.id !== action.payload.id);
      })
      .addCase(deleteTournament.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

// Defualt export
export default tournamentSlice.reducer;
